const ScrollLink = ((($) => {
  let scroller;

  function init() {
    scroller = $('.scroll-to');

    _attachEvents();
  }

  function _attachEvents() {
    scroller.click(_handleClickLink);
  }

  function _handleClickLink(e) {
    e.preventDefault();
    const id  = $(this).attr('href');
    const top = $(id).offset().top - 70;
    $('body,html').animate({scrollTop: top}, 1000);
  }

  return {
    init,
  };

}))(jQuery);

export default ScrollLink;



// WEBPACK FOOTER //
// ./src/static/js/modules/scroll-link.js